module.exports = __webpack_public_path__ + "static/media/19.c0d90118.png";